import React, { useCallback, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { generatePath, useHistory, useLocation, useParams } from 'react-router-dom';
import { FormCard, YupBoolean, YupString, isNumeric } from 'motion-components';
import * as Yup from 'yup';
import * as Lo from 'lodash';
import { gqlGetCntContributionTemplateById } from '../graphql';
import { FormFields } from './form-fields';
import { useHandleError } from 'shared-pages/services';
import { useTranslation } from 'react-i18next';
import { RowFieldTooltips } from 'shared-pages/components';
import { getRouteByName } from 'app/routes';
import { useRootStore } from 'store';

/** Φόρμα προβολής template εισφορών. Χωρίς αποθήκευση ή διαγραφή. */
export const CntContributionTemplateFormPage = () => {
  const { handleGraphqlError } = useHandleError('CntContributionTemplate');
  const { appStore } = useRootStore();
  const history = useHistory();
  const location: any = useLocation();
  const { id } = useParams<{ id: string }>();
  const idNum = isNumeric(id) ? parseInt(id) : -1;
  const { t } = useTranslation();

  const formShape = {
    id: Yup.number(),
    name: YupString,
    fromDate: YupString,
    tillDate: YupString,
    isActive: YupBoolean,
  };

  const validationSchema = Yup.object().shape(formShape);
  const pickProperties = (values) => Lo.pick(values, Lo.keys(formShape));

  const [get, { data: rawData, error }] = useLazyQuery(gqlGetCntContributionTemplateById);
  const data = rawData ? rawData[Object.keys(rawData)[0]] : undefined;

  useEffect(() => {
    if (idNum > 0) get({ variables: { id: idNum } });
  }, [get, idNum]);

  const handleReturn = useCallback(() => {
    history.push(generatePath(getRouteByName('CntContributionTemplates')), { ...location.state });
  }, [history, location.state]);

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  }

  if (!data) {
    return <h3 className="text-center">{t('Παρακαλώ περιμένετε...')}</h3>;
  }

  return (
    <FormCard
      title={`${t('Template Εισφορών')}: ${data?.name ?? ''}`}
      onSubmit={() => undefined}
      onReturn={handleReturn}
      permitSubmit={true}
      permitDelete={false}
      initialValues={pickProperties(data)}
      validationSchema={validationSchema}
      enableReinitialize
      idx={idNum}
    >
      <FormFields data={data} />
      {appStore.isPlatformOwner && (
        <RowFieldTooltips data={data} showLegacy={false} auditTable="cnt_contribution_templates" />
      )}
    </FormCard>
  );
};
